function HashController(){
	this.className			= "HashController";
	this.glob				= "/**";
	this.priority			= 999;
	this.globUseHash		= true;
};
HashController.inheritsFrom( StandardController );
HashController.prototype.swap = function(){

	this.$scrollElement		= $("body, html");	// what to scroll when navigating with aviator
	//this.headerController 	= Aviator.get('headerController');

	this.headerOffset = 150;
	this.scrollDuration = 0;

	return true;
}
HashController.prototype.on = function(){
	var state = nav.getState();

	// scroll to top when navigating to new page
	//this.$scrollElement.scrollTop(0);

	if(state.nextHash && $(`#${state.nextHash}`).length){
		this.hashScrollPosition = $(`#${state.nextHash}`).offset().top - this.headerOffset;
	}

	if(state.hasHashChanges){
		if(state.nextHash){
			//setTimeout(Igloo.delegate(this, function(){
			this.$scrollElement.animate({scrollTop: this.hashScrollPosition},{
				duration: this.scrollDuration,
				complete: Igloo.delegate(this, function(){
					//this.headerController.setSubmenuHeight(false); // Hide submenu
				})
			});
			//}), 10);
		}
	}

	return true;
};
/*
HashController.prototype.onScroll = function(){

}
*/